import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialExclusiveFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ExclusiveFilterData from "../../Exclusive/components/ExclusiveFilterData";


const ExclusiveArchieveFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("exclusiveArchiveSelectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialExclusiveFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("exclusiveArchiveFilterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const saveSearchFilterData = {
    count: filterData?.count ?? "",
    start_count: filterData?.start_count ?? "",
    end_count: filterData?.end_count ?? "",
  };


  const handleSelectFilter = (value) => {
    const dataToSet = {
      count: value?.count ?? "",
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",

    };
    localStorage.setItem("exclusiveArchiveFilterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  return (
    <div>
      <SavedFilterComponent
        filterKey="exclusiveArchiveFilterData"
        selectedFilterIdKey="exclusiveArchiveSelectedSavefilterId"
        from="Exclusive Archieves Save Filter"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialExclusiveFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        desc={`Enter Exclusive Information.`}
        onFilter={handleFilter}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        from={"Exclusive"}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <ExclusiveFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData}  from="exclusivearchieve" />
      </RightModal>
    </div>
  );
};

export default ExclusiveArchieveFilter;
